import {Table as MUITable} from '@mui/material'
import React from 'react'

interface TableProps extends React.ComponentProps<typeof MUITable> {}

export const Table: React.FC<TableProps> = (props) => {
  return <MUITable {...props} />
}
